<template>
  <div id="super_agi_linkedin_activity_analytics" class="flex flex-col gap-2">
    <LinkedinAnalyticsGrid />
    <LinkedinActivity />
  </div>
</template>

<script setup>
import LinkedinAnalyticsGrid from "@/src/views/analytics/v2/superagi_activity_analytics/linkedin/LinkedinAnalyticsGrid.vue";
import LinkedinActivity from "@/src/views/analytics/v2/superagi_activity_analytics/linkedin/LinkedinActivity.vue";
</script>
